import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "RolloutPane"*/ './lazyIndex'),
    { name: 'RolloutPane' }
);

export const RolloutOverridesPane: LazyComponent<unknown, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.RolloutOverridesPane
);

export const lazyOpenRolloutOverrides: LazyAction<
    typeof lazyIndex.openRolloutOverrides,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openRolloutOverrides);
